
import React from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface JUVButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'luxury' | 'outline';
  icon?: LucideIcon;
  iconPosition?: 'left' | 'right';
  glowEffect?: boolean;
  children: React.ReactNode;
}

const JUVButton = ({
  variant = 'primary',
  icon: Icon,
  iconPosition = 'left',
  glowEffect = false,
  className,
  children,
  ...props
}: JUVButtonProps) => {
  const variants = {
    primary: 'bg-juv-terracotta hover:bg-juv-deep-chestnut text-white shadow-apple',
    secondary: 'bg-white hover:bg-juv-soft-blush border border-juv-rose-clay/50 text-juv-deep-chestnut shadow-apple',
    ghost: 'bg-transparent hover:bg-juv-soft-blush/30 text-juv-deep-chestnut',
    luxury: 'bg-juv-gradient-primary hover:opacity-90 text-white shadow-luxury',
    outline: 'border-2 border-juv-terracotta text-juv-terracotta hover:bg-juv-terracotta hover:text-white'
  };

  return (
    <Button
      className={cn(
        'rounded-lg font-medium transition-all duration-300 apple-hover-scale',
        variants[variant],
        glowEffect && 'hover:shadow-glow',
        className
      )}
      {...props}
    >
      <div className="flex items-center gap-2">
        {Icon && iconPosition === 'left' && <Icon className="h-4 w-4" />}
        {children}
        {Icon && iconPosition === 'right' && <Icon className="h-4 w-4" />}
      </div>
    </Button>
  );
};

export default JUVButton;
